import { FileName } from './dataLayer';

enum FactTagSize {
  A4 = 1,
  A5 = 2,
  FactTag155x85 = 3,
  FactTag149x69 = 4,
  FactTag165x85 = 5,
  ReorderTags = 6,
  Flyer = 7,
  JSSA4 = 8,
  JSSA4Triple = 9,
  JSSA4Double = 10,
  JSS16x9 = 11,
  Datasheet = 12,
}

export const getFileDownloadInfo = (url: string): [FileName, string] => {
  if (url.includes('public-generation/generate')) {
    const queryParams = new URLSearchParams(url.split('?')[1]);
    const size = queryParams.get('facttagsize');

    if (!size) {
      return ['Other', 'pdf'];
    }

    switch (parseInt(size) as FactTagSize) {
      case FactTagSize.Flyer:
        return ['Product data A4', 'pdf'];
      case FactTagSize.A4:
        return ['Product data A4 Landscape', 'pdf'];
      case FactTagSize.A5:
        return ['Product data A5', 'pdf'];
      case FactTagSize.FactTag149x69:
        return ['Fact tag 14.9x6.9', 'pdf'];
      case FactTagSize.FactTag155x85:
        return ['Fact tag 15.5x8.5', 'pdf'];
      default:
        return ['Other', 'pdf'];
    }
  }

  if (url.includes('public-generation/data-sheet')) {
    return ['Product datasheet', 'pdf'];
  }

  // Format of the URLs (as per TTi Wiki) is the Agility ID, the type, then the culture code
  let filename = url.split('/').pop();

  if (!filename) {
    return ['Other', 'unknown'];
  }

  const extension = filename.split('.').pop() || 'unknown';

  filename = filename.split('?')[0]; // Remove query parameters if they exist

  const parts = filename.split('_');
  if (parts.length < 2) {
    return ['Other', extension];
  }

  let type = parts[1];
  if (!type) {
    return ['Other', extension];
  }

  // Remove the file extension
  type = type.split('.').shift() || type;

  switch (type.toLowerCase()) {
    case 'aoc':
      return ['Attestation of Conformity', extension];
    case 'doc':
      return ['Declaration of Conformity', extension];
    case 'ukca':
      return ['UKCA certificate', extension];
    case 'ce':
      return ['CE certificate', extension];
    case 'datasheet':
      return ['Product datasheet', extension];
    case 'sizeguide':
      return ['Size Guide', extension];
    case 'assumptionofliability':
      return ['Assumption of Liability', extension];
  }

  return ['Other', extension];
};
